import { useRef } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonInput,
    useIonAlert,
    IonFooter,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon
} from '@ionic/react';
import { addResource, deleteResource, setResource } from '../firebase/resources';
import { checkmark, chevronBack } from 'ionicons/icons';

const ResourceEditor = ({
    onDismiss,
    resource
}: {
    onDismiss: () => void,
    resource: any
}) => {

    const [presentAlert] = useIonAlert();

    const nameRef = useRef<HTMLIonInputElement>(null);
    const isNew = resource.resourceId === undefined;

    function confirm() {
        //update or create
        if (isNew) {
            addResource({ name: nameRef.current?.value + '' });
        } else {
            setResource({ name: nameRef.current?.value + '' }, resource.resourceId);
        }
        onDismiss();
    }



    function remove() {
        presentAlert({
            header: 'Usuwanie!',
            buttons: [
                {
                    text: 'Anuluj',
                    role: 'cancel'
                },
                {
                    text: 'Usuń',
                    role: 'confirm',
                },
            ],
            onDidDismiss: (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    deleteResource(resource.resourceId);
                    onDismiss();
                }
            },
        })

    }

    function cancel() {
        onDismiss();
    }


    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{isNew ? "Tworzenie pokoju" : "Edycja pokoju " + resource.resourceTitle}</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent style={{ height: '100%' }} className="ion-padding">
                <IonItem>
                    <IonLabel position="fixed">Nazwa</IonLabel>
                    <IonInput placeholder="Nazwa" ref={nameRef} value={resource.resourceTitle} ></IonInput>
                </IonItem>

            </IonContent>
            <IonFooter>
                {!isNew && resource.resourceTitle === "" ? <div><IonButton size="small" color="danger" onClick={() => remove()}>usuń</IonButton><br/><br/></div> : ""}    
            </IonFooter>
        </IonPage>
    );
};

export default ResourceEditor;

